<template>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <th>Name</th>
        <th>Routes</th>
        <th>Body Rent</th>
        <th>Total KM</th>
        <th>Total KM Earnings</th>
        <th>Total Lunch Allowance</th>
        <th>Total OT</th>
        <th>Total OT Earnings</th>
        <th>Others</th>
        <th>Adjustment</th>
        <th>Total Earnings</th>
      </thead>
      <tbody>
        <template
          v-for="(routeWiseTripIncome, key) in userRouteWiseTripIncome"
          :key="key"
        >
          <template
            v-if="
              routeWiseTripIncome.routeWiseTripIncome &&
              Array.isArray(routeWiseTripIncome.routeWiseTripIncome)
            "
          >
            <template
              v-for="(data, index) in routeWiseTripIncome.routeWiseTripIncome"
              :key="index"
            >
              <tr>
                <td
                  v-if="index == 0"
                  :rowspan="routeWiseTripIncome.routeWiseTripIncome.length"
                >
                  {{
                    billDriverDetails.find((driver) => driver.user_code === key)
                      ? billDriverDetails.find(
                          (driver) => driver.user_code === key
                        ).name
                      : 'No Name Found'
                  }}
                </td>
                <td>
                  <div
                    class="text-primary"
                    style="cursor: pointer"
                    @click="
                      $emit(
                        'switchTab',
                        key,
                        data.route_name?.replace(/[\s\(),-/]/g, '') +
                          '-tab' +
                          key +
                          index
                      )
                    "
                  >
                    {{ data.route_name }}
                    <span v-if="data.company_code"
                      >({{ data.company_code }})</span
                    >
                  </div>
                </td>
                <td>{{ data.body_rent ? '৳ ' + data.body_rent : 'N/A' }}</td>
                <td>
                  {{ data.total_km ? data.total_km + ' KM' : 'N/A' }}
                </td>
                <td>
                  {{ data.trip_income ? '৳ ' + data.trip_income : 'N/A' }}
                </td>
                <td>
                  {{
                    data.lunch_allowance ? '৳ ' + data.lunch_allowance : 'N/A'
                  }}
                </td>
                <td>
                  {{ data.body_rent ? data.over_time_hours + 'h' : 'N/A' }}
                </td>
                <td>
                  {{ data.body_rent ? '৳ ' + data.overtime : 'N/A' }}
                </td>
                <td>
                  {{ data.other_payment ? '৳ ' + data.other_payment : 'N/A' }}
                </td>
                <td
                  v-if="index == 0"
                  :rowspan="routeWiseTripIncome.routeWiseTripIncome.length"
                  style="vertical-align: middle"
                >
                  <span v-if="routeWiseTripIncome.adjustment"
                    >৳
                    {{
                      $format.floatingPointPlaces(
                        routeWiseTripIncome.adjustment.adjustment_credited -
                          routeWiseTripIncome.adjustment.adjustment_debited,
                        2
                      )
                    }}
                  </span>
                  <span v-else>৳ 0</span>
                </td>
                <td
                  v-if="index == 0"
                  :rowspan="routeWiseTripIncome.routeWiseTripIncome.length"
                  style="vertical-align: middle"
                >
                  ৳
                  {{
                    $format.floatingPointPlaces(
                      routeWiseTripIncome.totalIncome,
                      2
                    )
                  }}
                </td>
              </tr>
            </template>
          </template>
        </template>
        <tr>
          <td colspan="10" style="text-align: right">Total</td>
          <td>
            ৳
            {{ $format.floatingPointPlaces(grandTotalWeeklyIncome, 2) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['userRouteWiseTripIncome', 'billDriverDetails'],
  computed: {
    grandTotalWeeklyIncome() {
      let grandTotalWeeklyIncome = 0;

      for (const key in this.userRouteWiseTripIncome) {
        grandTotalWeeklyIncome += parseFloat(
          this.userRouteWiseTripIncome[key].totalIncome
        );
      }

      return grandTotalWeeklyIncome;
    }
  }
};
</script>

<style scoped>
table {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0px 0px;
  font-size: 15px;
  align-content: center;
}
table th,
table td {
  vertical-align: middle;
  padding: 0.5rem;
}
table thead {
  background-color: #f3f3f3;
}
table thead tr th {
  font-size: 13px;
  font-weight: 500;
  padding: 11px 15px;
}
table tbody {
  border-top: none !important;
}
table tbody tr td {
  font-size: 13px;
  font-weight: 400;
  padding: 10px 12px;
}
</style>
